<script>
import AvatarEditable from '@/components/AvatarEditable.vue';

export default {
  name: 'BaseTableEventItem',
  components: { AvatarEditable },
  props: {
    value: Object,
    type: String,
  },
};
</script>

<template lang="pug">
.b-table-event-cell
  ._cell-default(v-if="type === 'default'")
    ._cell-title {{ value.title  }}
    ._cell-value(v-if="value.value") {{ value.value  }}
    ._cell-title(v-if="value.addValue") {{ value.addValue  }}
  ._cell-tariff(v-if="type === 'tariff'")
    ._cell-title {{ value.title  }}
    ._cell-old-tariff-container
      ._cell-old-tariff {{ value.value }}
        ._cell-old-tariff-line
    ._cell-new-tariff {{ value.addValue }}
  ._cell-user(v-if="type === 'user'")
    ._cell-title {{ value.title  }}
    ._cell-value(v-if="value.value") {{ value.value  }}
    AvatarEditable._cell-avatar(:avatar="value.addValue" :editable="false")
</template>

<style scoped lang="scss">
.table-event-cell {
  &__cell-default {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__cell-title {
    color: rgb(30, 49, 71);
    font-family: Geometria, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    letter-spacing: normal;
    text-align: left;
  }

  &__cell-value {
    color: rgb(51, 161, 251);
    font-family: Geometria, sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 15px;
    letter-spacing: normal;
    text-align: left;
  }

  &__cell-tariff {
    display: flex;
    align-items: center;
    gap: 17px;
  }

  &__cell-old-tariff-container {
    padding: 0 4px;
    position: relative;
  }

  &__cell-old-tariff {
    border-radius: 4px;
    padding: 3px 5px;
    background: rgba(51, 161, 251, .5);
    color: rgba(255, 255, 255, .5);
    font-family: Geometria, sans-serif;
    font-size: 12px;
    font-weight: 700;
    line-height: 15px;
    letter-spacing: normal;
    text-align: center;
    margin: 0 auto;
  }

  &__cell-old-tariff-line {
    position: absolute;
    top: 50%;
    left: 0;
    background-color: rgba(120, 140, 161, .7);
    height: 2px;
    width: 100%;
  }

  &__cell-new-tariff {
    border-radius: 4px;
    padding: 3px 5px;
    background: rgba(51, 161, 251, 1);
    color: rgba(255, 255, 255, 1);
    font-family: Geometria, sans-serif;
    font-size: 12px;
    font-weight: 700;
    line-height: 15px;
    letter-spacing: normal;
    text-align: center;
  }

  &__cell-user {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__cell-avatar {
    width: 20px;
    height: 20px;
    box-sizing: border-box;
    border: 1px solid rgb(255, 255, 255);
    border-radius: 7px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  }
}
</style>
